import {BasicService} from './basic.service';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_MACHINE_TYPE_URL } from '../../connection.data';

@Injectable()
export class MachineTypeService extends BasicService {
    constructor(http: HttpClient){
        super(http);
        this.baseUrl = API_MACHINE_TYPE_URL;
    }
}